import { NewsfeedResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { DynamicItemsConfigEntry } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export enum PBasketView {
  Tile = 'tile',
  Grid = 'grid',
}

export type Pane = {
  content: DynamicItemsConfigEntry[] | null;
  title?: string | DynamicItemsConfigEntry[] | null;
  settings?: PaneSettings;
};

export type PaneSettings = {
  showCloseButton?: boolean;
  backdropClass?: string;
  className?: string;
  fancyItemId?: string;
  parentItemId?: string;
  isSelected?: boolean;
  isEditing?: boolean;
};

export type PaneLocation = keyof State['panes'];

export interface State {
  /** aside menu opened state */
  asideMenuOpened: boolean;
  userMenuOpened: boolean;
  mainHeaderHeight: number;
  /** feed state */
  singleColumnView: boolean | undefined; // tslint:disable-line:prefer-optional
  windowWidth: number;
  /** after placing an order, the ui state switches to `waiting new order`, the user could or not start placing a new order.
   * This is needed to know if the user just placed an order successfully
   */
  waitingNewOrder: boolean;
  presetFilter: string | null;
  overlaysOpened: number;
  pBasketView: PBasketView;
  expandedProductDetails: boolean;
  panes: {
    right: Pane;
    fancyListEditMenu: Pane;
  };
  promotedLandingPageFeed: NewsfeedResponseDto | null;
}
